import Icons from '@shared/components/core/images/Icons';
import {
    ActionWrapper,
    Content,
    EmptyContent,
    ListingCard,
    Table,
    TableHeading,
} from '@shared/components/core/listing/CommonListingStyles';
import { CardTitleCentered } from '@shared/components/core/text/CardTypography';
import { BodySmall } from '@shared/components/core/text/Typography';
import { commandTypesDisplay } from '@shared/constants/CommandValues';
import { getCommandDisplayName } from '@shared/hooks/helpers/profileUtils';
import { KeyCommandDisplayMapping } from '@shared/models/deviceProfiles/KeyCommandMapping';
import { useTranslation } from 'react-i18next';

export interface IKeyCommandListingProps {
    commandKeyMappings: KeyCommandDisplayMapping[];
    showDescription?: boolean;
}

function KeyCommandListing({ commandKeyMappings, showDescription = true }: IKeyCommandListingProps) {
    const { t } = useTranslation();
    return (
        <ListingCard>
            {commandKeyMappings.length > 0 ? (
                <>
                    <CardTitleCentered>{t('common:keys.title')}</CardTitleCentered>
                    {showDescription && <BodySmall>{t('common:keys.description')}</BodySmall>}

                    <Table>
                        <thead>
                            <ActionWrapper>
                                <Content as="th">
                                    <TableHeading>{t('common:when')}</TableHeading>
                                </Content>
                                <Content as="th">
                                    <TableHeading>{t('common:keys.then')}</TableHeading>
                                </Content>
                            </ActionWrapper>
                        </thead>
                        <tbody>
                            {commandKeyMappings.map((e, i) => {
                                const commands = e.commands;
                                return commands.map((c, commandId) => {
                                    const icon = commandTypesDisplay[c.commandType];
                                    return (
                                        <ActionWrapper key={`commandKeyMappings_${i}_${commandId}`}>
                                            <Content>
                                                <Icons name={icon.icon} size={24} ariaLabel={t(icon.title)} />
                                                <p>{getCommandDisplayName(c.command, t)}</p>
                                            </Content>
                                            <Content>
                                                <p>{e.displayName}</p>
                                                <Icons name={e.icon} size={24} ariaLabel={t('common:steps')} />
                                            </Content>
                                        </ActionWrapper>
                                    );
                                });
                            })}
                        </tbody>
                    </Table>
                </>
            ) : (
                <EmptyContent>{t('common:keys.empty')}</EmptyContent>
            )}
        </ListingCard>
    );
}

export default KeyCommandListing;
